class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");
    let stickyBarRafId = null;
    let stickyBarHeight = null;

    const updateStickyBarHeight = () => {
      if (!mobileStickyBar) return;
      if (stickyBarRafId) cancelAnimationFrame(stickyBarRafId);
      stickyBarRafId = requestAnimationFrame(() => {
        const nextHeight = Math.round(mobileStickyBar.getBoundingClientRect().height);
        if (nextHeight === stickyBarHeight) return;
        stickyBarHeight = nextHeight;
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${nextHeight}px`);
      });
    };

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      updateStickyBarHeight();
      document.addEventListener("matchMobile", () => {
        updateStickyBarHeight();
      });
      document.addEventListener("unmatchMobile", () => {
        updateStickyBarHeight();
      });
      window.addEventListener("resize", updateStickyBarHeight, { passive: true });
    }
  }
}
customElements.define("m-footer", MFooter);
